export const SumberDanaConstant = [
  {
    pk: 51,
    nama_sumber_dana: "Dana Masyarakat (BP) - Tidak Terikat",
  },
  {
    pk: 61,
    nama_sumber_dana: "Dana Masyarakat (Non BP) - Tidak Terikat",
  },
  {
    pk: 81,
    nama_sumber_dana: "Dana Khusus",
  },
];
